export default "__VITE_ASSET__BxtQFHWD__"